import { useMinhaEmpresa } from '@entregas/api/react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Carregando, ErroCarga } from '../ui';
import { ContextoLoja } from './loja';
import { useSessao } from './sessao';

function Espera() {
  return (
    <div style={{ maxWidth: 480, margin: '64px auto', padding: 16 }}>
      <Carregando linhas={2} />
    </div>
  );
}

/** Sem login → /entrar (guardando para onde a pessoa ia). */
export function RequerSessao() {
  const { sessao, carregando } = useSessao();
  const local = useLocation();
  if (carregando) return <Espera />;
  if (!sessao) return <Navigate to="/entrar" replace state={{ voltarPara: local.pathname }} />;
  return <Outlet />;
}

/**
 * Logado sem loja → /criar-loja. Com loja → entrega a loja às telas pelo contexto. Uma releitura que
 * falha (a volta à aba sem rede) mantém a loja do cache: o erro só toma a tela sem dado nenhum
 * (decisão 68), senão derrubaria o pedido sendo digitado.
 */
export function RequerLoja() {
  const loja = useMinhaEmpresa();
  if (loja.isPending) return <Espera />;
  if (loja.isError && !loja.data)
    return <ErroCarga erro={loja.error} onTentar={() => loja.refetch()} />;
  if (!loja.data) return <Navigate to="/criar-loja" replace />;
  return (
    <ContextoLoja.Provider value={loja.data}>
      <Outlet />
    </ContextoLoja.Provider>
  );
}
